import Flickity from 'flickity';

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.advert-slider').forEach(slider => {
        if (slider.children.length > 1) {
            new Flickity(slider, {
                cellAlign: 'left',
                contain: true,
                wrapAround: true,
                prevNextButtons: false,
                pageDots: false,
                draggable: true,
                autoPlay: 4000,
                imagesLoaded: true
            });
        }
    });
});
